export default "__VITE_ASSET__D$Cc59bP__"